export default "__VITE_ASSET__v19bgiwG__"